import React from "react";
import "../index";
import GlobalSearch from "./GlobalSearchComponent";

const GlobalSearchWidget = () => <GlobalSearch />;

export default GlobalSearchWidget;
